import { render } from "./FolderReport.vue?vue&type=template&id=5db1ee3c"
import script from "./FolderReport.vue?vue&type=script&lang=js"
export * from "./FolderReport.vue?vue&type=script&lang=js"

import "./FolderReport.vue?vue&type=style&index=0&id=5db1ee3c&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__